<template>
    <div class="contact view">
        <h1>Contact Formulieren</h1>
        <p>Hier vindt u al de ingevulde contactformulieren</p>
        <div class="contact__stats">
            <ContactStats/>
        </div>
        <div class="contact__cards">
            <ContactCard 
                v-for="contact in contacts"
                :key="contact"
                :f_id="contact.f_id"
                :naam="contact.voornaam + ' ' + contact.naam"
                :mail="contact.mail"
                :tel="contact.phone"
                :bericht="contact.bericht"
                :contactStatus="contact.status"
                :klant="contact.klant"
            />
        </div>
    </div>
</template>
<script>
import ContactCard from '../components/contact/ContactCard.vue'
import ContactStats from '../components/contact/ContactStats.vue'
export default {
    inject:["status", "data"],
    components:{
        ContactStats,
        ContactCard
    },
    data(){
        return{
            contacts: []
        }
    },
    created(){
        this.contacts = this.data.database.test_db.contact.forms;
    }
}
</script>